<app-section-header
    [title]="headerConfig().reportData?.name || ''"
    [iconName]="'goBack'"
    [subTitle]="headerConfig().reportSubtitle ?? ''"
    [actionsTemplate]="actionsTemplate"
    [mainAdditionalTemplate]="statusTemplate"
>
</app-section-header>

<ng-template #statusTemplate>
    @if (showSchedulerStatus()) {
        <app-report-scheduler-status-indicator
            [schedulerStatusId]="headerConfig().reportData.schedulerStatusId"
        ></app-report-scheduler-status-indicator>
    }
</ng-template>

<ng-template #actionsTemplate>
    <div class="actions">
        <button class="secondary-btn" (click)="saveAsCustom()">Save as custom</button>
        @if (headerConfig().canUpdateReport) {
            <button class="resetStyles tertiary-btn save-btn" libTooltip [tooltip]="'Save'" (click)="save()">
                <div class="icon" [innerHTML]="saveIcon"></div>
            </button>
        }

        @if (showDownload()) {
            <lib-dropdown-panel
                class="download-btn"
                [buttonTemplateRef]="downloadCSVref"
                [source]="headerConfig().downloadPanel!"
                libTooltip
                [tooltip]="'Download'"
            ></lib-dropdown-panel>
        }
        <ng-template #downloadCSVref>
            <div class="icon download" [innerHTML]="downloadIcon"></div>
        </ng-template>

        @if (showShare()) {
            <button class="tertiary-btn share-btn" libTooltip [tooltip]="'Share'" (click)="share()">
                <div class="icon" [innerHTML]="shareIcon"></div>
            </button>
        }

        @if (headerConfig().canScheduleReport) {
            <button class="tertiary-btn scheduler-btn" libTooltip [tooltip]="'Schedule'" (click)="schedule()">
                <div class="icon" [innerHTML]="scheduleIcon"></div>
            </button>
        }

        @if (showKebabMenu()) {
            <app-kebab-menu libTooltip [tooltip]="'Options'">
                @if (headerConfig().canUpdateReport) {
                    <button role="menuitem" class="resetStyles tertiary-btn" (click)="edit()">Edit</button>
                }
                @if (showFavoriteOption()) {
                    <button role="menuitem" class="resetStyles tertiary-btn" (click)="toggleFavorite()" tabindex="0">
                        {{ headerConfig().reportData?.isFavorite ? 'Remove Favorite' : 'Add to Favorite' }}
                    </button>
                }
                @if (headerConfig().canDeleteReport) {
                    <button role="menuitem" class="resetStyles tertiary-btn" (click)="deleteReport()">Delete</button>
                }
            </app-kebab-menu>
        }
    </div>
</ng-template>
